import cartHandler from '@components/services/cart'
import {
  Messages,
  API_STATUS,
  EmptyGuid,
  AppsFlyerKeys,
  AppsFlyerParams,
} from '@components/utils/constants'
import {
  GENERAL_ADD_TO_BAG,
  PROD_ADDED_SUCCESSFULLY,
  INSUFFICIENT_STOCK,
  BTN_NOTIFY_ME,
  BTN_PRE_ORDER,
  GENERAL_ADD_TO_BASKET,
} from '@components/utils/textVariables'
import {
  validateAddToCart,
  isCartAssociated,
  openNewCartPage,
  getCommonAppsFlyerValue,
  getlineItemSizeWithoutSlug,
} from '@framework/utils/app-util'
import { isEmpty } from '@framework/utils/lodash'
import { matchStrings } from '@framework/utils/parse-util'
import { MO_ENGAGE_EVENT } from 'hooks/moengage_event.modal'

export const buttonTitle = ({
  productData,
  cartItems,
  setAlert,
  setLoader,
  product,
  selectedAttrData,
  setQuickview,
  basketId,
  user,
  replacementEligibilityDays,
  returnEligibilityDays,
  openCart,
  setCartItems,
  AF,
  window,
  isFromCart,
  collectionName,
  getBasketPromo,
  addToCartGAEvent,
  trackMoEngageEvent,
  handleNotification,
}: {
  user: any
  basketId: any
  selectedAttrData: any
  product: any
  productData: any
  cartItems: any
  setAlert: any
  setLoader: any
  openCart: any
  setQuickview: any
  setCartItems: any
  replacementEligibilityDays: number | null
  returnEligibilityDays: number | null
  AF: any
  window: any
  isFromCart: boolean
  collectionName: string
  addToCartGAEvent: (productData: any) => Promise<void>
  handleNotification: () => void
  getBasketPromo: (basketId: string) => Promise<any>
  trackMoEngageEvent: (
    eventName: MO_ENGAGE_EVENT,
    params?: Object | undefined,
    window?: any
  ) => void
}) => {
  let buttonConfig: any = {
    title: GENERAL_ADD_TO_BAG,
    validateAction: async () => {
      const cartLineItem: any = cartItems?.lineItems?.find(
        (o: any) => o.productId === productData?.productId?.toUpperCase()
      )
      if (productData?.currentStock === cartLineItem?.qty) {
        setAlert({
          type: 'error',
          msg: Messages.Errors['CART_ITEM_QTY_MAX_ADDED'],
        })
        return false
      }
      const isValid = validateAddToCart(
        productData?.productId ?? productData?.recordId,
        cartItems
      )
      if (!isValid) {
        setAlert({
          type: 'error',
          msg: Messages.Errors['CART_ITEM_QTY_LIMIT_EXCEEDED'],
        })
      }
      return isValid
    },
    action: async () => {
      setLoader && setLoader(API_STATUS.LOADING)
      const productObj = product?.variantProducts?.find(
        (item: any) => item?.stockCode === selectedAttrData?.stockCode
      )
      let basketItemData = productData
      let originalSize = ''

      const ctrlSizes: any = document.querySelectorAll(
        'div.quick-view a.select-product-size'
      )
      if (ctrlSizes?.length) {
        ctrlSizes?.forEach((size: any) => {
          if (size?.parentElement?.classList.contains('border-gray-800')) {
            originalSize = size?.innerText?.trim()
            return
          }
        })
      }

      const currentSize =
        productData?.customAttributes?.find((x: any) =>
          matchStrings(x?.key, 'clothing.size', true)
        )?.value || ''

      if (!matchStrings(originalSize, currentSize, true)) {
        basketItemData = productData?.variantProducts?.find(
          (x: any) =>
            x?.attributes
              ?.find((attr: any) => attr?.fieldCode === 'clothing.size')
              ?.fieldValue?.toLowerCase() === originalSize.toLowerCase()
        )
      }
      setQuickview(undefined)
      const item = await cartHandler().addToCart(
        {
          basketId: basketId,
          // productId: basketItemData?.productId,
          productId: productObj?.productId,
          qty: 1,
          // manualUnitPrice: basketItemData?.price?.raw?.withTax,
          // stockCode: basketItemData?.stockCode,
          stockCode: productObj?.stockCode,
          userId: user?.userId,
          isAssociated: isCartAssociated(cartItems), //user?.isAssociated,
          CustomInfo4: JSON.stringify({
            formatted: {
              title: 'Replacement Eligibility',
              data: {
                'Replacement Eligibility': replacementEligibilityDays || null,
              },
            },
          }),
          CustomInfo5: JSON.stringify({
            formatted: {
              title: 'Return Eligibility',
              data: { 'Return Eligibility': returnEligibilityDays || null },
            },
          }),
          CustomInfo4Formatted: replacementEligibilityDays?.toString() || '',
          CustomInfo5Formatted: returnEligibilityDays?.toString() || '',
        },
        'ADD',
        { product: productData },
        (item: any) => {
          // setCartItems(item)
          // openCart()
        }
      )
      // setCartItems(item)

      if (
        item?.message &&
        !matchStrings(item?.message, PROD_ADDED_SUCCESSFULLY, true)
      ) {
        setAlert({ type: 'error', msg: INSUFFICIENT_STOCK })
      } else if (item?.id === EmptyGuid) {
        setAlert({ type: 'error', msg: INSUFFICIENT_STOCK })
      } else {
        setCartItems(item)
        addToCartGAEvent(productData)
        openNewCartPage(openCart, 'item_added')
      }
      setLoader && setLoader(API_STATUS.SUCCESS)

      if (typeof AF !== 'undefined') {
        const commonEventValue = getCommonAppsFlyerValue()
        AF('pba', 'event', {
          eventType: 'EVENT',
          eventName: AppsFlyerKeys.AddToCart,
          eventRevenueCurrency: 'INR',
          eventValue: {
            [AppsFlyerParams.AFEventParam3]: isFromCart
              ? 'Cart'
              : collectionName,
            [AppsFlyerParams.AFEventParamRevenue]:
              productData?.price?.raw?.withTax + '',
            [AppsFlyerParams.AFEventParamContent]: productData?.name,
            [AppsFlyerParams.AFEventParamContentId]: productData?.stockCode,
            [AppsFlyerParams.AFEventParamPrice]:
              productData?.price?.raw?.withTax + '',
            [AppsFlyerParams.AFEventParamQuantity]: 1 + '',
            [AppsFlyerParams.AFEventParam5]:
              productData?.mappedCategories[2]?.categoryName || '',
            [AppsFlyerParams.AFEventParam6]:
              productData?.mappedCategories[0]?.categoryName || '',
            ...commonEventValue,
          },
        })
      }

      trackMoEngageEvent(
        MO_ENGAGE_EVENT.ADD_TO_CART,
        {
          Product_size: getlineItemSizeWithoutSlug(productData),
          URL: window?.location?.href,
          Cart_quantity: 1,
          Cart_total: productData?.price?.raw?.withTax,
          Product_name: productData?.name,
          Product_ID: productData?.stockCode,
          Price: productData?.price?.raw?.withTax,
          label: 'Quick View',
          action: 'Click',
          Quantity: 1,
          Image: productData?.image,
          Product_category: productData?.mappedCategories[0]?.categoryName,
          Product_category_2: productData?.mappedCategories[1]?.categoryName,
          Product_color: productData?.variantGroupCode,
        },
        window
      )
    },
    shortMessage: '',
  }
  if (
    productData &&
    productData?.currentStock <= 0 &&
    !product.preOrder?.isEnabled
  ) {
    if (
      !product?.flags?.sellWithoutInventory ||
      !productData.sellWithoutInventory
    ) {
      buttonConfig.title = BTN_NOTIFY_ME
      buttonConfig.action = async () => handleNotification()
      buttonConfig.type = 'button'
    }
  } else if (
    productData &&
    product?.preOrder?.isEnabled &&
    productData?.currentStock <= 0
  ) {
    if (
      product?.preOrder?.currentStock < product.preOrder.maxStock &&
      (!product.flags.sellWithoutInventory || productData.sellWithoutInventory)
    ) {
      buttonConfig.title = BTN_PRE_ORDER
      buttonConfig.shortMessage = product.preOrder.shortMessage
      return buttonConfig
    } else if (
      product?.flags?.sellWithoutInventory ||
      productData.sellWithoutInventory
    ) {
      buttonConfig = {
        title: GENERAL_ADD_TO_BASKET,
        validateAction: async () => {
          const cartLineItem: any = cartItems?.lineItems?.find(
            (o: any) => o.productId === productData?.productId?.toUpperCase()
          )
          if (productData?.currentStock === cartLineItem?.qty) {
            setAlert({
              type: 'error',
              msg: Messages.Errors['CART_ITEM_QTY_MAX_ADDED'],
            })
            return false
          }
          const isValid = validateAddToCart(
            productData?.productId ?? productData?.recordId,
            cartItems
          )
          if (!isValid) {
            setAlert({
              type: 'error',
              msg: Messages.Errors['CART_ITEM_QTY_LIMIT_EXCEEDED'],
            })
          }
          return isValid
        },
        action: async () => {
          setLoader && setLoader(API_STATUS.LOADING)
          const productObj = product?.variantProducts?.find(
            (item: any) => item?.stockCode === selectedAttrData?.stockCode
          )
          const item = await cartHandler().addToCart(
            {
              basketId: basketId,
              productId: productObj?.productId,
              qty: 1,
              // manualUnitPrice: product?.price?.raw?.withTax,
              stockCode: productObj?.stockCode,
              userId: user.userId,
              isAssociated: isCartAssociated(cartItems), //user.isAssociated,
              CustomInfo4: JSON.stringify({
                formatted: {
                  title: 'Replacement Eligibility',
                  data: {
                    'Replacement Eligibility':
                      replacementEligibilityDays || null,
                  },
                },
              }),
              CustomInfo5: JSON.stringify({
                formatted: {
                  title: 'Return Eligibility',
                  data: {
                    'Return Eligibility': returnEligibilityDays || null,
                  },
                },
              }),
              CustomInfo4Formatted:
                replacementEligibilityDays?.toString() || '',
              CustomInfo5Formatted: returnEligibilityDays?.toString() || '',
            },
            'ADD',
            { product: productData },
            (item: any) => {
              // setCartItems(item)
              // openCart()
            }
          )

          // setCartItems(item)
          if (
            item?.message &&
            !matchStrings(item?.message, PROD_ADDED_SUCCESSFULLY, true)
          ) {
            setAlert({ type: 'error', msg: INSUFFICIENT_STOCK })
          } else if (item?.id === EmptyGuid) {
            setAlert({ type: 'error', msg: INSUFFICIENT_STOCK })
          } else {
            setCartItems(item)
            addToCartGAEvent(productData)
            openNewCartPage(openCart, 'item_added')
          }
          setLoader && setLoader(API_STATUS.SUCCESS)
          // if (currentPage !== CURRENT_PAGE.CART) {
          //   trackGoogleAnalyticsEvent(
          //     GA_EVENT.ADD_TO_CART,
          //     {
          //       ecommerce: {
          //         items: [
          //           {
          //             item_name: productData?.name,
          //             item_brand: productData?.brand,
          //             item_category2: getCategories(productData).category2,
          //             item_category: getCategories(productData).category,
          //             item_variant: productData?.customAttributes?.find(
          //               (x: any) => x?.key === 'global.colour'
          //             )?.valueText,
          //             color: productData?.customAttributes?.find(
          //               (x: any) => x?.key === 'global.colour'
          //             )?.valueText,
          //             quantity: 1,
          //             item_id: productData?.sku,
          //             // item_id: productData?.productCode,
          //             // item_size: getlineItemSizeWithoutSlug(productData),
          //             price: productData?.price?.raw?.withTax,
          //             item_var_id: productData?.stockCode,
          //             item_list_name: getCategories(productData).category,
          //             index: 1,
          //           },
          //         ],
          //         cart_quantity: 1,
          //         device: deviceCheck,
          //         total_value: productData?.price?.raw?.withTax,
          //         current_page: currentPage,
          //         section_title: collectionName,
          //         loggedin_status: !!(
          //           user?.userId && user?.userId !== EmptyGuid
          //         ),
          //       },
          //     },
          //     window
          //   )
          // }

          if (typeof AF !== 'undefined') {
            const commonEventValue = getCommonAppsFlyerValue()
            AF('pba', 'event', {
              eventType: 'EVENT',
              eventName: AppsFlyerKeys.AddToCart,
              eventRevenueCurrency: 'INR',
              eventValue: {
                [AppsFlyerParams.AFEventParam3]: 'PLP ' + collectionName,
                [AppsFlyerParams.AFEventParamRevenue]:
                  productData?.price?.raw?.withTax + '',
                [AppsFlyerParams.AFEventParamContent]: productData?.name,
                [AppsFlyerParams.AFEventParamContentId]: productData?.stockCode,
                [AppsFlyerParams.AFEventParamPrice]:
                  productData?.price?.raw?.withTax + '',
                [AppsFlyerParams.AFEventParamQuantity]: 1 + '',
                [AppsFlyerParams.AFEventParam5]:
                  productData?.mappedCategories[2]?.categoryName || '',
                [AppsFlyerParams.AFEventParam6]:
                  productData?.mappedCategories[0]?.categoryName || '',
                ...commonEventValue,
              },
            })
          }

          trackMoEngageEvent(
            MO_ENGAGE_EVENT.ADD_TO_CART,
            {
              Product_size: getlineItemSizeWithoutSlug(productData),
              URL: window?.location?.href,
              Cart_quantity: 1,
              Cart_total: productData?.price?.raw?.withTax,
              Product_name: productData?.name,
              Product_ID: productData?.stockCode,
              Price: productData?.price?.raw?.withTax,
              label: 'Quick View',
              action: 'Click',
              Quantity: 1,
              Image: productData?.image,
              Product_category: productData?.mappedCategories[0]?.categoryName,
              Product_category_2:
                productData?.mappedCategories[1]?.categoryName,
              Product_color: productData?.variantGroupCode,
            },
            window
          )
        },
        shortMessage: '',
      }
    } else {
      buttonConfig.title = BTN_NOTIFY_ME
      buttonConfig.action = async () => handleNotification()
      buttonConfig.type = 'button'
      return buttonConfig
    }
  }
  return buttonConfig
}
